var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.breadcrumb)?_c('div',{staticClass:"breadcrumb-container"},[_c('fin-breadcrumb',{attrs:{"separator":"/"}},[_c('fin-breadcrumb-item',[_vm._v(_vm._s(_vm.breadcrumb))])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }